import React, { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import SecondaryButton from '../../components/SecondaryButton';
import { paths } from '../../constants';
import styles from './SingleSignOnLogin.module.scss';

export const SingleSignOnLogin = (): JSX.Element => {
    const { t: txt } = useTranslation();
    const navigate = useNavigate();
    const { search } = useLocation();

    const loginClick = (event: SyntheticEvent<HTMLButtonElement>): void => {
        event.preventDefault();
        navigate({ pathname: paths.singleSignOnLogin, search });
    };

    return (
        <div>
            <SecondaryButton onClick={loginClick} title={'SingleSignOn.SsoSignIn'} />
            <p className={styles.divider}>{txt('SingleSignOn.Or')}</p>
            <div className={styles.header}>{txt('SingleSignOn.AirthingsAccount')}</div>
        </div>
    );
};
